/* 更多配置请看echarts官网
https://echarts.apache.org/zh/option.html#title */
import { COLOR_LIST } from "../config"

const formatter = (arg) => {
    if (Array.isArray(arg.data)) return `${arg.data[0]}: ${arg.data[1]}（${arg.percent}%）`
    if (Object.isObj(arg.data)) return `${arg.data.product || arg.data[arg.dimensionNames[0]]}: ${arg.data[arg.dimensionNames[1]]}（${arg.percent}%）`
}

export function defaultSeriesSettings (radius = [10, 95], center = ["52%", "45%"], roseType, duration = 850) {
    return {
        type: "pie",
        radius, /* 参数1 为内圈半径，参数2 为外圈半径 */
        center, // 调整饼图位置
        roseType, /* radius 南丁格尔玫瑰图  area 圆心角相同半径展示大小 */
        animationEasing: "cubicInOut",
        animationDurationUpdate: duration,
        itemStyle: {
            emphasis: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: "rgba(0, 0, 0, 0.5)"
            }
        },
        label: {
            formatter: formatter
        }
    }
}
// 默认配置
export default function defaultSettings () {
    return {
        color: COLOR_LIST,
        legend: {
            orient: "horizontal", /* vertical */
            left: "center",
            bottom: 20,
            icon: "roundRect",
            padding: 5
            // icon: 'circle', 'rect', 'roundRect', 'triangle', 'diamond', 'pin', 'arrow', 'none',
        },
        title: {
            text: "pieChart",
            left: "center",
            top: "10px",
            textStyle: {
                fontSize: 18,
                color: "#000",
                fontWeight: 600
            }
        },
        tooltip: {
            trigger: "item",
            // formatter: '{a} <br/>{b} : {c} ({d}%)',
            formatter: formatter,
            backgroundColor: "rgba(0,0,0, .4)",
            textStyle: {
                color: "#fff"
            }
        },
        series: [defaultSeriesSettings()]
    }
}
